import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
} from 'recharts';
import { Card, CardContent, Typography } from '@mui/material';
import CustomCard from '../../../../components/ui/customCard';

export function RevenueEvolutionChart({ data }) {
  return (
    <CustomCard >
      <CardContent>
        <Typography fontWeight="bold" mb={2}>
          Évolution du chiffre d’affaires
        </Typography>

        <ResponsiveContainer width="100%" height={280}>
          <LineChart data={data}>
            <XAxis dataKey="date" />
            <YAxis />
            <Tooltip />
            <Line type="monotone" dataKey="amount" strokeWidth={3} />
          </LineChart>
        </ResponsiveContainer>
      </CardContent>
    </CustomCard>
  );
}
